import {
  QUESTION_FORMAT,
  type AnsweredQuestion,
  type Form,
  type Address,
  type RequestOrigin,
} from './types';
import type { State } from './JobRefinement.reducer';

export const contentFullIdToType: Record<string, string> = {
  '018f809e-31fe-7ccd-b906-b4876df0c556': 'Flexible',
  '018f809e-5354-74c8-85e7-9aa6dead0de6': 'Urgent',
  '018f809e-721e-71fb-b52d-3312dffdc86f': 'Within2Weeks',
  '018f809e-ad12-7811-ad8d-1d138f0e211d': 'Within1Month',
  '018f809e-8be9-7d90-837e-3a16b6d017f2': 'InPlanning',
  '018f809e-bdf9-4c32-a918-f52ccf194d78': 'ReadyToBook',
};

export const getPreferredStart = (answeredQuetion?: AnsweredQuestion) => {
  return (
    answeredQuetion?.answers.map(a => {
      const option = (a.key && contentFullIdToType[a.key]) || '';
      return {
        label: a.value,
        option,
        level: option === 'Urgent' ? 48 : undefined,
      };
    })[0] || {}
  );
};

const filterUnnecessaryQuestions = (answeredQuetion: any[]) => {
  const finalAnswers = [];
  for (const answer of answeredQuetion.values()) {
    if (
      ![
        QUESTION_FORMAT.JOB_DESCRIPTION,
        QUESTION_FORMAT.JOB_PREFERRED_STARTS,
        QUESTION_FORMAT.PHOTO_UPLOAD,
      ].includes(answer.format)
    ) {
      finalAnswers.push(answer);
    }
  }

  return finalAnswers;
};

export const formatJobRefinementForm = (
  form: Form,
  answeredQuetion: Map<string, AnsweredQuestion>,
) => {
  return {
    formId: form.formId,
    experimentId: form.experimentId || '',
    variant: form.variant,
    questions: filterUnnecessaryQuestions(Array.from(answeredQuetion.values())),
  };
};

export const setSessionStoragePostcode = (postcode: string) => {
  if (typeof sessionStorage !== 'undefined')
    sessionStorage.setItem('postcodes', postcode);
};

export const getJobRefinementStorageName = (form: {
  formId: string;
  categoryId: number;
  variant?: string;
}) => {
  return `cat-job-refinement-${form.formId}-${form.categoryId}${form.variant || ''}`;
};

const JOB_TYPE: Record<RequestOrigin, string> = {
  search: 'RequestAQuote',
  profile: 'DirectMessage',
  message: 'DirectMessage',
  'post-a-job': 'RequestAQuote',
  'alternative-trades': 'RequestAQuote',
  'pre-select': 'RequestAQuote',
};

export const getTransformedJobBlob = (
  {
    category,
    origin,
    companyId,
    answeredQuestions,
    form,
    serviceId,
    serviceVersionId,
  }: State,
  address?: Address,
) => {
  const preferredStart = getPreferredStart(
    answeredQuestions.get('job-preferred-start-default'),
  );

  return {
    categoryId: category?.id,
    type: JOB_TYPE[origin ?? 'search'],
    preferredStart,
    leads: companyId ? [companyId] : [],
    additionalData: [],
    description: answeredQuestions.get('job-description-default')?.answers[0]
      .value,
    from: origin,
    postcode: address?.postcode,
    mediaAttachmentIds:
      answeredQuestions
        .get('job-photo-upload-default')
        ?.answers.map(a => a.id) || [],
    jobRefinementForm: formatJobRefinementForm(form, answeredQuestions),
    serviceId,
    serviceVersionId,
  };
};
